const articleContent: string[] = [
	`Let's not solutionize this right now parking lot it dunder mifflin or let's not solutionize
	this right now parking lot it big picture if you could do that, that would be great yet we
	need to future-proof this quick-win. Re-inventing the wheel pulling teeth locked and loaded
	screw the pooch, yet goalposts this is meaningless.`,
	`We're ahead of the curve on that one red flag, but incentivization marketing computer
	development html roi feedback team website but prairie dogging. Bob called an all-hands this
	afternoon can we align on lunch orders, and we need to dialog around your choice of work attire,
	yet we need to leverage our synergies blue money.`,
	`Quick win drop-dead date high turnaround rate, translating our vision of having a market leading
	platfrom for strategic high-level 30,000 ft view. Even dead cats bounce.`,
]

export default articleContent
